
import { defineComponent, ref } from 'vue';
import UpdateBzy from './components/update-bzy.vue';
import UpdateZy from './components/update-zy.vue';
import Card from './components/card/index.vue';
import { IApp } from './type.d';

export default defineComponent({
  components: {
    UpdateBzy,
    UpdateZy,
    Card,
  },
  setup() {
    const APPS = [
      // { name: '直销 APP', code: 'INNER_APP', updateType: 'UpdateInner' },
      // { name: '百布 APP', code: 'BAIBU_APP', updateType: 'UpdateOutside' },
      { name: '找布易 APP', code: 'SELLER_APP', updateType: 'UpdateOutside' },
      // { name: '八爪鱼 APP', code: 'octopus_app', updateType: 'UpdateBzy' },
      // { name: '致衣 APP', code: 'zhicloth_app', updateType: 'UpdateZy' },
      // { name: '天工 APP', code: 'tiangong_app', updateType: 'UpdateBzy' },
    ];
    const currentApp = ref<IApp>({
      ...APPS[0],
    });
    const updateComponent = ref<string>(currentApp.value.updateType);
    const handleChangeAppType = (val: 'SRM_APP') => {
      const app = APPS.find((item: IApp) => item.code === val) || {} as IApp;
      // 直接赋值对象改为对象属性（基础数据类型）拷贝
      currentApp.value = {
        ...app,
      };
      updateComponent.value = app.updateType;
    };

    return {
      APPS,
      handleChangeAppType,
      currentApp,
      updateComponent,
    };
  },
});
